module.exports = "https://web-assets-production.autolist.com/_next/static/images/miami-fl-d7222093bff891ec26bfe4413edbf5b2.jpg";